import { Employeur } from '../employeur';

export class UpdateEmploiIndividual 
{
    individualId: number|undefined;
    employeur : Employeur;
    employerName : String;
    employerAdresse : String;
    dateEmbauche : String;
    ancienneteEmploi : number;
    profession : String;
    fonctionDansEntreprise : String;
    workPhone : String;
}